enum BusinessBranchFeedbackType {
    None,
    Default,
    SignupSource,
    CancellationRequest,
    ResolvedCancellationRequest
}

export default BusinessBranchFeedbackType
